module.exports = __webpack_public_path__ + "static/media/icon-movie.ebf1a846.svg";